import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const PopupNew = ({ openPopup, setOpenPopup, title, children, width, height }) => {
  return (
    <Dialog
      open={openPopup}
      onClose={() => setOpenPopup(false)}
      fullWidth={false}
      maxWidth="md"
      PaperProps={{
        style: {
          width: width || "600px",
          height: height || "auto",
          padding: "16px",
          borderRadius: "10px",
          position: "relative",
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, fontWeight: "bold" }}>
        {title}
        <IconButton
          aria-label="close"
          onClick={() => setOpenPopup(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ padding: "16px" }}>{children}</Box>
      </DialogContent>
    </Dialog>
  );
};

export default PopupNew;